import Link from "next/link";
import Avatar from "../../../components/Avatar";
import UserAvatar from "../../UserAvatar";
import { AvatarTypes } from "@chesshotel/constants";

export default function PlayerAvatar({
  isUser,
  isGuest,
  gameEnded,
  avatarId,
  fbId,
  avatarType,
  id,
}) {
  if (isGuest) {
    return (
      <Avatar
        id={null}
        avatarType={AvatarTypes.GUEST}
        avatarId={null}
        fbId={null}
        className="w-8 h-8 m-0 md:w-11 md:h-11"
      />
    );
  }

  if (isUser) {
    return <UserAvatar className="w-8 h-8 m-0 md:w-11 md:h-11" />;
  }

  if (gameEnded && !isGuest) {
    return (
      <Link href={`/user?userId=${id}&link=game`}>
        <Avatar
          avatarType={avatarType}
          avatarId={avatarId}
          fbId={fbId}
          id={id}
          className="w-8 h-8 m-0 cursor-pointer md:w-11 md:h-11 hover:opacity-70"
        />
      </Link>
    );
  }
  return (
    <Avatar
      avatarType={avatarType}
      avatarId={avatarId}
      fbId={fbId}
      id={id}
      className="w-8 h-8 m-0 md:w-11 md:h-11"
    />
  );
}
